import * as React from 'react';
import { PageTypeEnum } from '@doltech/utils/lib/constants';
import dynamic from 'next/dynamic';
import { LandingBlogDetailCommonLayout } from '@doltech/ui/lib/shared/templates/LandingBlog/LandingBlogDetailCommonLayout';

const BlogIeltsReviewDetailTemplatePage = dynamic(
  () => import('../templates/BlogIeltsReviewDetailTemplatePage'),
  {
    loading: () => <LandingBlogDetailCommonLayout loading />,
  }
);

const ViewBlogTemplatePage = dynamic(() => import('../templates/ViewBlogTemplatePage'), {
  loading: () => <LandingBlogDetailCommonLayout loading />,
});

export const PageTemplate = (props) => {
  const { pageType, pageProps } = props;
  return (
    <>
      {pageType === PageTypeEnum.IELTS_INFO_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}

      {pageType === PageTypeEnum.READING_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}

      {pageType === PageTypeEnum.BOOK_REVIEW_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.CENTER_REVIEW_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.TEACHER_REVIEW_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.COURSE_REVIEW_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}

      {pageType === PageTypeEnum.LISTENING_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.WRITING_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.SPEAKING_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.VOCAB_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.GRAMMAR_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.DOL_NEWS_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.DOL_LINEAR_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
      {pageType === PageTypeEnum.STUDENT_STORY_IELTS_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <BlogIeltsReviewDetailTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}

      {pageType === PageTypeEnum.VIEW_BLOG && (
        <LandingBlogDetailCommonLayout {...props}>
          <ViewBlogTemplatePage {...pageProps} />
        </LandingBlogDetailCommonLayout>
      )}
    </>
  );
};
